import axios from 'axios'

export const ACTIONS = {
  companies: {
	  search:{
	    statuses: {
		    completed: 'SEARCH_COMPANIES_COMPLETE',
		    requested: 'SEARCH_COMPANIES_REQUESTED',
		    error: 'SEARCH_COMPANIES_ERROR',
	    },
	    url: '/api/companies/search'
	  },
	  index:{
	    statuses: {
		    completed: 'INDEX_COMPANIES_COMPLETE',
		    requested: 'INDEX_COMPANIES_REQUESTED',
		    error: 'INDEX_COMPANIES_ERROR',
	    },
	    method: 'POST',
	    url: '/api/companies/filter'
	  },
	  score_distribution:{
	    statuses: {
		    completed: 'SCORE_DISTRIBUTION_COMPANIES_COMPLETE',
		    requested: 'SCORE_DISTRIBUTION_COMPANIES_REQUESTED',
		    error: 'SCORE_DISTRIBUTION_COMPANIES_ERROR',
	    },
	    method: 'GET',
	    url: '/api/companies/score_distribution'
	  },
	  expositions_scores:{
	    statuses: {
		    completed: 'SCORE_EXPOSITIONS_SCORES_COMPLETE',
		    requested: 'SCORE_EXPOSITIONS_SCORES_REQUESTED',
		    error: 'SCORE_EXPOSITIONS_SCORES_ERROR',
	    },
	    method: 'GET',
	    url: '/api/companies/expositions_scores'
	  },
	  show: (id) => {
	    
	    return {
		    statuses: {
		      completed: 'SHOW_COMPANIES_COMPLETE',
		      requested: 'SHOW_COMPANIES_REQUESTED',
		      error: 'SHOW_COMPANIES_ERROR',
		    },
		    url: `/api/companies/${id}`
	    }
	  },
	  create:{
	    statuses: {
		    completed: 'CREATE_COMPANIES_COMPLETE',
		    requested: 'CREATE_COMPANIES_REQUESTED',
		    error: 'CREATE_COMPANIES_ERROR',
	    },
	    method: 'POST',
	    url: '/api/companies'
	  },
	  analysis:{
	    statuses: {
		    completed: 'CREATE_ANALYSIS_COMPLETE',
		    requested: 'CREATE_ANALYSIS_REQUESTED',
		    error: 'CREATE_ANALYSIS_ERROR',
	    },
	    method: 'POST',
	    url: '/api/companies/analysis'
	  },
	  
	  select: 'SELECT_COMPANIES_COMPLETE'
  },
  reports: {
	  create: (company_id) => {
	    return {
		    statuses: {
		      completed: 'CREATE_REPORTS_COMPLETE',
		      requested: 'CREATE_REPORTS_REQUESTED',
		      error: 'CREATE_REPORTS_ERROR',
		    },
		    method: 'POST',
		    url: `/api/companies/${company_id}/reports`
	    }
	  },
	  update: (id) => {
	    return {
		    statuses: {
		      completed: 'UPDATE_REPORTS_COMPLETE',
		      requested: 'UPDATE_REPORTS_REQUESTED',
		      error: 'UPDATE_REPORTS_ERROR',
		    },
		    method: 'PUT',
		    url: `/api/reports/${id}`
	    }
	  }
  },
  products: {
	  index: {
	    statuses: {
		    completed: 'INDEX_PRODUCTS_COMPLETE',
		    requested: 'INDEX_PRODUCTS_REQUESTED',
		    error: 'INDEX_PRODUCTS_ERROR',
	    },
	    url: '/api/products'
	  },
	  update: (id) => {
	    return {
	      statuses: {
		      completed: 'UPDATE_PRODUCTS_COMPLETE',
		      requested: 'UPDATE_PRODUCTS_REQUESTED',
		      error: 'UPDATE_PRODUCTS_ERROR',
	      },
	      method: 'PUT',
	      url: `/api/products/${id}`
	    }
	  }
	  
  },
  credits_logs: {
	  index: {
	    statuses: {
		    completed: 'INDEX_CREDITS_LOGS_COMPLETE',
		    requested: 'INDEX_CREDITS_LOGS_REQUESTED',
		    error: 'INDEX_CREDITS_LOGS_ERROR',
	    },
	    url: '/api/credits_logs'
	  },
	  create: (id) => {
	    return {
		    statuses: {
		      completed: 'CREATE_CREDITS_LOGS_COMPLETE',
		      requested: 'CREATE_CREDITS_LOGS_REQUESTED',
		      error: 'CREATE_CREDITS_LOGS_ERROR',
		    },
		    method: 'POST',
		    url: `/api/credits/${id}/credits_logs/`
	    }
	  },
  },
  credits: {
	  index: {
	    statuses: {
		    completed: 'INDEX_CREDITS_COMPLETE',
		    requested: 'INDEX_CREDITS_REQUESTED',
		    error: 'INDEX_CREDITS_ERROR',
	    },
	    url: '/api/credits'
	  },
	  create: {
	    statuses: {
		    completed: 'CREATE_CREDITS_COMPLETE',
		    requested: 'CREATE_CREDITS_REQUESTED',
		    error: 'CREATE_CREDITS_ERROR',
	    },
	    method: 'POST',
	    url: '/api/credits'
	  },
	  update: (id) => {
	    return {
	      statuses: {
		      completed: 'UPDATE_CREDITS_COMPLETE',
		      requested: 'UPDATE_CREDITS_REQUESTED',
		      error: 'UPDATE_CREDITS_ERROR',
	      },
	      method: 'PUT',
	      url: `/api/credits/${id}`
	    }
	  },
	  delete: (id) => {
	    return {
		    statuses: {
		      completed: 'DELETE_CREDITS_COMPLETE',
		      requested: 'DELETE_CREDITS_REQUESTED',
		      error: 'DELETE_CREDITS_ERROR',
		    },
		    method: 'DELETE',
		    url: `/api/credits/${id}`
	    }
	  }
  },
  groups: {
	  index: {
	    statuses: {
		    completed: 'INDEX_GROUPS_COMPLETE',
		    requested: 'INDEX_GROUPS_REQUESTED',
		    error: 'INDEX_GROUPS_ERROR',
	    },
	    url: '/api/groups'
	  },
	  create:{
	    statuses: {
		    completed: 'CREATE_GROUPS_COMPLETE',
		    requested: 'CREATE_GROUPS_REQUESTED',
		    error: 'CREATE_GROUPS_ERROR',
	    },
	    method: 'POST',
	    url: '/api/groups'
	  },
	  update: (id) => {
	    return {
	      statuses: {
		      completed: 'UPDATE_GROUPS_COMPLETE',
		      requested: 'UPDATE_GROUPS_REQUESTED',
		      error: 'UPDATE_GROUPS_ERROR',
	      },
	      method: 'PUT',
	      url: `/api/groups/${id}`
	    }
	  },
	  delete: (id) => {
	    return {
		    statuses: {
		      completed: 'DELETE_GROUPS_COMPLETE',
		      requested: 'DELETE_GROUPS_REQUESTED',
		      error: 'DELETE_GROUPS_ERROR',
		    },
		    method: 'DELETE',
		    url: `/api/groups/${id}`
	    }
	  }
  },
  users: {
	  index: {
	    statuses: {
		    completed: 'INDEX_USERS_COMPLETE',
		    requested: 'INDEX_USERS_REQUESTED',
		    error: 'INDEX_USERS_ERROR',
	    },
	    url: '/api/users'
	  },
	  current: {
	    statuses: {
		    completed: 'CURRENT_USER_COMPLETE',
		    requested: 'CURRENT_USER_REQUESTED',
		    error: 'CURRENT_USER_ERROR',
		    unauthorized: 'CURRENT_USER_UNAUTHORIZED_COMPLETE',
	    },
	    url: '/api/users/current'
	  },
	  create:{
	    statuses: {
		    completed: 'CREATE_USERS_COMPLETE',
		    requested: 'CREATE_USERS_REQUESTED',
		    error: 'CREATE_USERS_ERROR',
	    },
	    method: 'POST',
	    url: '/api/users'
	  },
	  signin:{
	    statuses: {
		    completed: 'SIGNIN_USERS_COMPLETE',
		    requested: 'SIGNIN_USERS_REQUESTED',
		    error: 'SIGNIN_USERS_ERROR',
	    },
	    method: 'POST',
	    url: '/api/users/signin'
	  },
	  signout:{
	    statuses: {
		    completed: 'SIGNOUT_USERS_COMPLETE',
		    requested: 'SIGNOUT_USERS_REQUESTED',
		    error: 'SIGNOUT_USERS_ERROR',
	    },
	    method: 'DELETE',
	    url: '/api/users/signout'
	  },
	  update: (id) => {
	    return {
	      statuses: {
		      completed: 'UPDATE_USERS_COMPLETE',
		      requested: 'UPDATE_USERS_REQUESTED',
		      error: 'UPDATE_USERS_ERROR',
	      },
	      method: 'PUT',
	      url: `/api/users/${id}`
	    }
	  },
	  delete: (id) => {
	    return {
		    statuses: {
		      completed: 'DELETE_USERS_COMPLETE',
		      requested: 'DELETE_USERS_REQUESTED',
		      error: 'DELETE_USERS_ERROR',
		    },
		    method: 'DELETE',
		    url: `/api/users/${id}`
	    }
	  }
  }
  
}

export const stdAction = (action, params, successAction) => {
  return (dispatch) => {
	  dispatch({type: action.statuses.requested})
	  let req = axios
	  switch  (action.method){
	      
	    case 'POST': {
	      req = req.post(action.url, params)
	      break;
	    }
	    case 'PUT': {
	      req = req.put(action.url, params)
	      break;
	    }
	    case 'DELETE': {
	      req = req.delete(action.url, params)
	      break;
	    }
	    default:
	      req = req.get(action.url, {
		      params: params
	      })
	  } 
	  return req.then(function (response) {
	    if(successAction != null)
		    successAction()
	    return dispatch({type: action.statuses.completed, data: response.data})
	  }).catch(function (error) {
	    if (error.response && error.response.status == 401) 	
		  dispatch({type: ACTIONS.users.current.statuses.unauthorized})
	    
	    return dispatch({type: action.statuses.error, data: error.response!=null ? error.response.data : {}}) 
	  })
  }
}
